<template>
	<Page
		ref="page"
		:type="pageData.type"
		:slug="pageData.metadata.slug"
		:name="pageData.name"
		:metadata="pageData.metadata"
	>
		<Landing />
	</Page>
</template>

<script setup>
import { Page } from '~/components/core'
import { Landing } from '/components/pages'

const page = ref(null)

const meta = {
	slug: 'home',
	title: '18 FKN Years Book',
	description:
		'18 years in the making. Our studio’s journey through design craft, now captured in a very special book',
	keywords: '',
	image: {
		url: '/imgs/social.jpg',
		width: 1200,
		height: 600,
	},
	head: {
		tags: [{ name: 'google-site-verification', content: '' }],
		scripts: [
			{
				async: false,
				defer: true,
				src: 'https://cloud.umami.is/script.js',
				'data-website-id': '06abd5b8-7299-4098-95db-f36583f9443b',
				'data-domains': 'book.burocratik.com',
			},
		],
	},
}

const pageData = {
	type: 'page.home',
	name: 'Bürocratik Book',
	metadata: meta,
}
</script>
